module.exports = __webpack_public_path__ + "img/feature-tile-icon-01.9c64d0dd.svg";